
  import React from "react"
  import Component from "/home/runner/work/SCION/SCION/projects/examples/sciblog/src/layouts/index.js"
  import data from "/home/runner/work/SCION/SCION/projects/examples/sciblog/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js